import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { NamedColorsHEX, ScreenSizesPx } from '../util/styles';
import { Button } from 'ui-components/build';
import { useAuthentication } from '../context/AuthenticationProvider';
import { useGiftees } from '../context/GifteesProvider';
import { Gender } from 'shared/build/enums';
import { customFetch } from '../util/functions';
import { FullscreenSpinner } from '../components/FullscreenSpinner';

const ScWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  padding: 100px 10px 0 10px;
  @media screen and (min-width: ${ScreenSizesPx.large}px) {
    padding-top: 200px;
  }

  h4 {
    margin-top: 0;
    margin-bottom: 30px;
    text-align: left;
    color: ${NamedColorsHEX.LightSlateGray};
    font-weight: light;
  }

  h4:first-child {
    font-weight: bold;
  }

  h4:nth-child(2) {
    color: ${NamedColorsHEX.DarkSeaTurquoise};
  }
`;

const ScLineOfItems = styled.div`
  display: flex;
  flex-direction: ${Math.ceil(Math.random() * 100) % 2 === 0
    ? 'row'
    : 'row-reverse'};
  width: 100%;
  justify-content: space-evenly;
`;

const ScButton = styled(Button)`
  transition: 0.1s;

  color: black;
  &.male:hover,
  &.male.selected {
    background-color: ${NamedColorsHEX.PantoneCeruleanBlue};
  }
  &.female:hover,
  &.female.selected {
    background-color: ${NamedColorsHEX.PantonePixie};
  }
`;

export const GuessTheGender = () => {
  const { user } = useAuthentication();
  const { gifteesIncludingNonSelected } = useGiftees();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [userNames, setUserNames] = useState<string>('');

  useEffect(() => {
    if (!user) return;

    setUserNames(
      user.names
        .map<string>((user) => `${user.title || ''} ${user.name}`.trim())
        .join(' e ')
    );
  }, [user]);

  const [selectedGender, setSelectedGender] = useState<Gender | undefined>();

  const selectOneGender = async (gender: Gender) => {
    setSelectedGender(gender);
    setIsLoading(true);

    const response = await customFetch(`/api/website/guess-gender/${gender}`, {
      method: 'PUT',
    });

    if (!response.ok) {
      console.error(response.statusText);
    } else {
      window.location.href = '/inicio';
    }

    setIsLoading(false);
  };

  if (!user) return null;

  return (
    <ScWrapper className="babys-page-padding">
      <FullscreenSpinner show={isLoading} />
      <h4>Olá {userNames}!</h4>
      <h4>
        {user.names.length === 1 ? 'Você acha' : 'Vocês acham'} que será...
      </h4>
      <ScLineOfItems>
        {gifteesIncludingNonSelected.map((giftee, i) => {
          if (giftee.gender === undefined) return null;

          return (
            <ScButton
              key={i}
              onClick={() => selectOneGender(giftee.gender || Gender.female)}
              className={`${giftee.gender} ${
                selectedGender === giftee.gender
              } ? 'selected' : ''`}
            >
              {giftee.gifteeName()}
            </ScButton>
          );
        })}
      </ScLineOfItems>
    </ScWrapper>
  );
};
